// Simple localStorage-based wishlist
const WISHLIST_KEY = 'techorini_wishlist';

function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  } catch (e) {
    return [];
  }
}

function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

function isInWishlist(handle) {
  return getWishlist().some(item => item.handle === handle);
}

function toggleWishlist(product) {
  let items = getWishlist();
  const exists = items.some(item => item.handle === product.handle);

  if (exists) {
    items = items.filter(item => item.handle !== product.handle);
  } else {
    items.push(product);
  }

  saveWishlist(items);
  updateButtonStates();
  return !exists; // returns true if just added, false if just removed
}

function updateButtonStates() {
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    const handle = btn.getAttribute('data-product-handle');
    if (isInWishlist(handle)) {
      btn.classList.add('is-wishlisted');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      btn.classList.remove('is-wishlisted');
      btn.setAttribute('aria-pressed', 'false');
    }
  });
}

function renderWishlistPage() {
  const container = document.querySelector('#wishlist-grid');
  if (!container) return;

  const items = getWishlist();

  if (items.length === 0) {
    container.innerHTML = '<p class="wishlist-empty">Your wishlist is empty. Browse our <a href="/collections/all">full catalog</a> to add items.</p>';
    return;
  }

  container.innerHTML = items.map(item => `
    <div class="wishlist-card" data-handle="${item.handle}">
      <a href="${item.url}">
        <img src="${item.image}" alt="${item.title}" loading="lazy">
        <h3>${item.title}</h3>
        <p>${item.price}</p>
      </a>
      <button class="wishlist-remove" data-remove-handle="${item.handle}">Remove</button>
    </div>
  `).join('');

  container.querySelectorAll('.wishlist-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const handle = btn.getAttribute('data-remove-handle');
      let items = getWishlist().filter(item => item.handle !== handle);
      saveWishlist(items);
      renderWishlistPage();
      updateButtonStates();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateButtonStates();
  renderWishlistPage();

  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;

    e.preventDefault();

    const product = {
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      url: btn.getAttribute('data-product-url')
    };

    toggleWishlist(product);
  });
});